import React from 'react';
import './error-page.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-box">
        <h1>🚧 404 - Page Not Found</h1>
        <p>Sorry! The page you're looking for doesn't exist or has been moved.</p>
        <a href="/" className="close-button">
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
